import gql from 'graphql-tag';

export default gql`
  mutation dropEvent($message: String!) {
    drop(message: $message)
  }
`;
